import React from 'react';
import cn from 'classnames';
import { HeaderPersonIcon } from '@repo/icons';
import styles from './WelcomeGuide.module.scss';

export default function AvatarFallback({ className }) {
  return (
    <div
      className={cn('avatar', styles.avatarFallback, className)}
      style={{
        width: 62,
        height: 62,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255,255,255,0.8)',
        borderRadius: '50%',
      }}
    >
      <HeaderPersonIcon width={36} height={36} customColor="rgba(255,0,0,0.3)" />
    </div>
  );
}
